export default __webpack_public_path__ + "static/media/logo_scorpion.e8268d39.png";